/**
 * @generated SignedSource<<2fc344987abcec2dd5b87d7b2fa3ebff>>
 * @relayHash 9d663ac50e64b4ff80140ec729f0bcdc
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID dc1a69514e07927a54fb109c019c19ac5017ab2866f4f04e33de4e8e600fe1b8

import { ConcreteRequest } from 'relay-runtime';
export type getEmailCliAuthQuery$variables = Record<PropertyKey, never>;
export type getEmailCliAuthQuery$data = {
  readonly viewer: {
    readonly email: string;
  } | null | undefined;
};
export type getEmailCliAuthQuery = {
  response: getEmailCliAuthQuery$data;
  variables: getEmailCliAuthQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "getEmailCliAuthQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "getEmailCliAuthQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "9d663ac50e64b4ff80140ec729f0bcdc",
    "id": "dc1a69514e07927a54fb109c019c19ac5017ab2866f4f04e33de4e8e600fe1b8",
    "metadata": {},
    "name": "getEmailCliAuthQuery",
    "operationKind": "query",
    "text": "query getEmailCliAuthQuery {\n  viewer {\n    email\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "fa890a7aa03b2bfd755eaac9d12811a8";

export default node;
